export const style = {
  list: {
    marginTop: `0px`,
    marginBottom: `10px`
  },
  listItem: {
    color: `#666`,
    fontSize: `14px`,
    lineHeight: `23px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Advertisers/style/lists.js